import React, { AllHTMLAttributes, useEffect, useMemo, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util, XtLocale } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { waitRes } from "@/utils/axios";
import XtPagination, { PaginationProps, PaginationRefProps } from "@/components/Xt/Pagination/Simple";
import { delete_clientDevice, get_safeLog, get_clientDevice, delete_clientDeviceClear } from "@/api/uaapi/uaa";
import clearEquipImg from "@/assets/images/account/icon-trashbin-darkmode.png";
import AccountTable from "../_CMPT/Table";
import { ColumnsType } from "antd/lib/table";
import { Modal, message } from "antd";
import useNextTick from "@/hooks/useNextTick";

interface DataType {
  city: string;
  country: string;
  describe: string;
  id: number;
  ip: string;
  province: string;
  result: string;
  terminal: number;
  terminalName: string;
  time: number;
  type: string;
}
interface CustomEquipmentDataProps {
  children?: EquipementChildrenProps[];
  len?: number;
  isOpen?: boolean;
  hasChildren?: boolean;
  id: number;
}

interface EquipmentDataProps {
  deviceName: string;
  id: number;
  lastLoginCity: string;
  lastLoginCountry: string;
  ip: string;
  lastLoginProvince: string;
  times: number;
  clientDeviceId: string;
  clientDeviceName: string;
  country: string;
  province: string;
  city: string;
}
type EquipementChildrenProps = Omit<EquipmentDataProps, keyof CustomEquipmentDataProps>;
interface LoginLogProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
}
const { useTranslation, useDocumentWidth } = Hooks;
const { Big, moment } = Util;
const LoginLog: React.FC<LoginLogProps> = ({ className }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  const docW = useDocumentWidth();
  const nextTick = useNextTick();
  // useRef
  const paginationRef = useRef<WithNull<PaginationRefProps>>(null);
  const [selectedTab, setSelectedTab] = useState(1);
  const [pageIndex, setPageIndex] = useState(1);
  const [limit, setLimit] = useState(10); // limit 定义每页要查几条数据
  const [fromId, setFromId] = useState("");
  const [direction, setDirection] = useState("NEXT");
  const [hasPrev, setHasPrev] = useState(false);
  const [hasNext, setHasNext] = useState(false);
  const [data, setData] = useState<DataType[]>([]); // 登录日志数据
  const [equipmentData, setEquipmentData] = useState<EquipmentDataProps[]>([]); // 设备信息数据
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false);
  const [isShowDeleteAllModal, setIsShowDeleteAllModal] = useState(false);
  const [loading] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState({} as EquipmentDataProps);
  // useEffect

  useEffect(() => {
    if (selectedTab == 1) {
      getSafeLog();
    } else {
      handleGetTableData();
    }
  }, [pageIndex]);

  // useMemo
  const columns = useMemo<ColumnsType<DataType>>(() => {
    return [
      {
        title: t("account.time"),
        dataIndex: "time",
        width: "20%",
        render: (text, record, index) => {
          return moment(text).formatMs();
        },
      },
      {
        title: t("account.ActionType"),
        width: "10%",
        dataIndex: "type",
        render: (text) => {
          return text === "login" ? t("app.login") : text;
        },
      },
      {
        title: t("account.OperatingTerminal"),
        width: "10%",
        dataIndex: "terminalName",
      },
      {
        width: "30%",
        title: t("account.IPAddress") + "/" + t("account.City"),
        render: (text, record) => {
          const { ip, country, province, city } = record;
          if (country && province && city) {
            return `${ip}(${country}-${province}-${city})`;
          }
          if (country && !province && city) {
            return `${ip}(${country}-${city})`;
          }
          if (country && province && !city) {
            return `${ip}(${country}-${province})`;
          }

          if (!country && province && city) {
            return `${ip}(${province}-${city})`;
          }

          if (!country && province && !city) {
            return `${ip}(${province})`;
          }

          return ip + "(Unknown)";
        },
      },
      {
        width: "10%",
        title: t("account.Result"),
        dataIndex: "result",
        render: (text, record) => {
          return text === "success" ? t("account.success") : t("account.Failed");
        },
      },
      {
        width: "10%",
        title: t("account.Description"),
        dataIndex: "describe",
        render: (text, record) => {
          return text === "login" ? t("app.login") : text;
        },
      },
    ];
  }, []);

  const equipmentColumns = useMemo<ColumnsType<EquipmentDataProps>>(() => {
    return [
      {
        title: t("newAccount.equipments"),
        width: "30%",
        render: (text, record) => {
          return <span>{record.clientDeviceName}</span>;
        },
      },
      {
        title: t("account.time"),
        width: "30%",
        render: (text, record) => {
          if (typeof record.times == "number") {
            return new Date(record.times).toLocaleString().replaceAll("/", "-");
          }
          // return (
          //   <span className={styles["equipmentBtn"]} onClick={() => handleShowAllInfo(record)}>
          //     {record.times}
          //   </span>
          // );
        },
      },
      {
        title: t("newAccount.loginArea"),
        width: "30%",
        render: (text, record) => {
          const { country, province, city } = record;

          if (country && province && city) {
            return `${country}-${province}-${city}`;
          }
          if (country && !province && city) {
            return `${country}-${city}`;
          }
          if (country && province && !city) {
            return `${country}-${province}`;
          }

          if (!country && province && city) {
            return `${province}-${city})`;
          }

          if (!country && province && !city) {
            return `${province}`;
          }

          return city || "Unknown";
          // const { lastLoginCountry, lastLoginProvince, lastLoginCity } = record;

          // if (lastLoginCountry && lastLoginProvince && lastLoginCity) {
          //   return `${lastLoginCountry}-${lastLoginProvince}-${lastLoginCity}`;
          // }
          // if (lastLoginCountry && !lastLoginProvince && lastLoginCity) {
          //   return `${lastLoginCountry}-${lastLoginCity}`;
          // }
          // if (lastLoginCountry && lastLoginProvince && !lastLoginCity) {
          //   return `${lastLoginCountry}-${lastLoginProvince}`;
          // }

          // if (!lastLoginCountry && lastLoginProvince && lastLoginCity) {
          //   return `${lastLoginProvince}-${lastLoginCity})`;
          // }

          // if (!lastLoginCountry && lastLoginProvince && !lastLoginCity) {
          //   return `${lastLoginProvince}`;
          // }

          // return lastLoginCity || "Unknown";
        },
      },
      {
        title: t("account.IPAddress"),
        dataIndex: "ip",
        width: '10%',
      },
      {
        title: t("newAccount.tabelOperate"),
        width: '10%',
        render: (text, record) => {
          return (
            <div className={styles["equipmentBtn"]} onClick={() => handleDeleteEquipment(record)}>
              {t("newAccount.delete")}
            </div>
          );
        },
      },
    ];
  }, []);

  const showPage = useMemo(() => {
    return !!hasNext || !!hasPrev;
  }, [hasNext, hasPrev]);

  // method
  const handleDeleteEquipment = (row: EquipmentDataProps) => {
    setIsShowDeleteModal(true);
    setSelectedEquipment({ ...row });
  };

  // 获取登录日志
  const getSafeLog = async () => {
    const { data: res, err } = await waitRes(get_safeLog, {
      params: {
        fromId,
        limit,
        direction,
      },
    });
    if (!err) {
      const data = (res && res.items) || [];
      const pageCount = res.items?.length || 0;
      setData(data);
      setHasPrev(!!res.hasPrev);
      setHasNext(!!res.hasNext);
      nextTick(() => {
        if (!paginationRef.current) return;
        paginationRef.current.enableNext(!res.hasNext);
      });
    }
  };

  // 获取设备管理数据
  const handleGetTableData = async () => {
    const { data: res, err } = await waitRes(get_clientDevice, { params: { fromId, limit, direction } });
    if (!err) {
      const { items } = res;
      console.log(res, "res");
      const pageCount = items?.length || 0;
      setEquipmentData(items || []);
      setHasPrev(!!res.hasPrev);
      setHasNext(!!res.hasNext);
      // items.forEach((item: EquipmentDataProps) => {
      //   if (item.clientDeviceCnt > 1) {
      //     item.children = [];
      //   }
      //   item.len = items.length;
      //   item.isOpen = false;
      //   item.hasChildren = true;
      //   item.id = Math.floor(Math.random() * 1000000) + 123;
      // });
      nextTick(() => {
        if (!paginationRef.current) return;
        paginationRef.current.enableNext(!res.hasNext);
      });
    }
  };

  const handleChangeTab = (tab: number) => {
    setSelectedTab(tab);
    if (pageIndex == 1) {
      if (tab == 1) {
        getSafeLog();
      } else {
        handleGetTableData();
      }
    } else {
      setPageIndex(1);
      setFromId("");
      setDirection("NEXT");
    }
  };

  /** 废弃 */
  // const handleExpandedRowsChange = (expanded: boolean, row: EquipmentDataProps) => {
  //   if (row.isOpen) return;
  //   row.isOpen = true;
  //   handleGetChildTable(row);
  // };

  /* 废弃 */
  // const handleGetChildTable = async (row: EquipmentDataProps) => {
  //   const { data: res, err } = await waitRes(get_detaillist, { params: { clientDeviceId: row.clientDeviceId, clientDeviceName: row.clientDeviceName } });
  //   if (!err) {
  //     let arr: EquipementChildrenProps[] = res || [];
  //     if (res.length >= 6) {
  //       arr.push({
  //         times: t("acount.viewmore"),
  //         clientDeviceId: row.clientDeviceId,
  //         clientDeviceName: row.clientDeviceName,
  //       });
  //     }
  //     arr.forEach((item) => {
  //       item.id = Math.floor(Math.random() * 1000000) + 123;
  //     });
  //     row.children = arr;
  //     setEquipmentData([...equipmentData]);
  //   }
  // };

  const handlePreBtn: PaginationProps["prepage"] = (cb) => {
    const page = pageIndex - 1;
    const fromId = data[0]?.id + "" || "";
    setPageIndex(page);
    setFromId(fromId);
    setDirection("PREV");
    cb && cb();
  };
  const handleNextBtn: PaginationProps["nextpage"] = (cb) => {
    const page = pageIndex + 1;
    const fromId = data[data.length - 1]?.id + "" || "";
    setPageIndex(page);
    setFromId(fromId);
    setDirection("NEXT");
  };

  const handleDeleteTrue = async () => {
    const { err } = await waitRes(delete_clientDevice, {
      errorPop: true,
      data: {
        clientDeviceId: selectedEquipment.clientDeviceId,
        clientDeviceName: selectedEquipment.clientDeviceName,
      },
    });
    if (err) return;
    message.success(t("account.success"));
    setIsShowDeleteModal(false);
    handleGetTableData();
    const id = localStorage.getItem("client-device-id") || "";
    if (+id == selectedEquipment.id) {
      localStorage.removeItem("client-device-id");
    }
  };

  const handleDeleteAllTrue = async () => {
    const { err } = await waitRes(delete_clientDeviceClear, {
      errorPop: true,
    });
    if (!err) {
      message.success(t("account.success"));
      setIsShowDeleteAllModal(false);
      handleGetTableData();
      localStorage.removeItem("client-device-id");
    }
  };
  return (
    <div className={cx(styles.loginLog, className)}>
      <div className={styles["loginLog_nav"]}>
        <div className={cx(styles["loginLog_nav_item"], selectedTab == 1 ? styles["active"] : "")} onClick={() => handleChangeTab(1)}>
          {t("account.LoginLog")}
        </div>
        <div className={cx(styles["loginLog_nav_item"], selectedTab == 2 ? styles["active"] : "")} onClick={() => handleChangeTab(2)}>
          {t("newAccount.equipmentManage")}
        </div>
        <div
          className={cx(styles["loginLog_claerAllBtn"], styles["pc-btn"])}
          style={{ display: selectedTab == 2 && equipmentData.length > 0 && docW > 768 ? "block" : "none" }}
          onClick={() => setIsShowDeleteAllModal(true)}
        >
          <img src={clearEquipImg} alt="" />
          {t("newAccount.clearAll")}
        </div>
      </div>
      <div
        className={cx(styles["loginLog_claerAllBtn"], styles["mb-btn"])}
        style={{ display: selectedTab == 2 && equipmentData.length > 0 && docW < 768 ? "block" : "none" }}
        onClick={() => setIsShowDeleteAllModal(true)}
      >
        <img src={clearEquipImg} alt="" />
        {t("newAccount.clearAll")}
      </div>
      <div className={cx(styles["loginLog_container"])}>
        {selectedTab == 1 ? (
          <AccountTable key={"logtable"} columns={columns} data={data} loading={loading} scroll={{ x: 'max-content' }} />
        ) : (
          <AccountTable key="equipmenttable" columns={equipmentColumns} data={equipmentData} loading={loading} scroll={{ x: 'max-content' }} /* onExpand={handleExpandedRowsChange} */ />
        )}
        {showPage && (
          <XtPagination ref={paginationRef} className={cx(styles["list-paging"])} pageIndex={pageIndex} prepage={handlePreBtn} nextpage={handleNextBtn} />
        )}
      </div>
      <Modal
        className={cx(styles["delete-modal"])}
        width={400}
        open={isShowDeleteModal}
        title={t("newAccount.deleteEquipment")}
        onCancel={() => setIsShowDeleteModal(false)}
        onOk={handleDeleteTrue}
        cancelText={t("newAccount.cancel")}
        okText={t("newAccount.isDelete")}
      >
        <div>
          <span>{t("newAccount.equipments")}: </span>
          <span>{selectedEquipment.clientDeviceName}</span>
        </div>
      </Modal>

      <Modal
        className={cx(styles["delete-modal"])}
        width={400}
        open={isShowDeleteAllModal}
        title={t("newAccount.clearAll")}
        onCancel={() => setIsShowDeleteAllModal(false)}
        onOk={handleDeleteAllTrue}
        cancelText={t("newAccount.cancel")}
        okText={t("newAccount.clearAllTrue")}
      >
        <div>
          <span>{t("newAccount.clearAllTips")}: </span>
        </div>
      </Modal>
    </div>
  );
};
export default observer(LoginLog);
